import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { Container, Grid, Toolbar, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import {
  createFacility,
  deleteFacilityById,
  getClinicFacilities,
  getLocations,
  updateFacilityById,
} from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { delBtn, w20h20BlueIcon } from "../../../util/CommonIconStyle";
import { facilityTypes } from "../../../util/dropList";

const requiredFieldList = ["facilityType", "name", , "primaryStorage"];
const tblHdrs = [
  "sNo",
  "name",
  "facilityType",
  "newStatus",
  "createdBy",
  "createdDate",
  "actions",
];

const nameExpan = {
  ConsultationRoom: "Consultation Room",
  OperationTheatre: "Operation Theatre",
  Kennel: "Kennel",
  Devices: "Devices",
  BathBays: "Bath Bays",
  HomeKit: "Home Kit",
};

const Facilities = () => {
  const dispatch = useDispatch();
  const locationsAndFacilitiesFetchedRef = useRef(false);
  const [searchValue, setSearchValue] = useState("");
  const [modVisible, setModVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modValues, setModValues] = useState({});
  const [modErrors, setModErrors] = useState({});
  const [delModVisible, setDelModVisible] = useState(false);
  const { locationList, facilities, selectedClinicBranch } = useSelector(
    (state) => state?.clinic,
  );
  const role = localStorage.getItem("role");
  const url =
    role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
      ? `?clinicId=${selectedClinicBranch?.branchId}`
      : null;

  useEffect(() => {
    if (locationsAndFacilitiesFetchedRef.current) return;
    if (role === "ROLE_DOCTOR") {
      if (!selectedClinicBranch?.branchId) return;
      locationsAndFacilitiesFetchedRef.current = true;
      const reqUrl = `?clinicId=${selectedClinicBranch?.branchId}`;
      onLocationApiCall(reqUrl);
      onFacilitiesApiCall(reqUrl);
      return;
    }
    locationsAndFacilitiesFetchedRef.current = true;
    onLocationApiCall();
    onFacilitiesApiCall();
  }, [selectedClinicBranch, role, dispatch]);

  const onLocationApiCall = (url = "") => {
    dispatch(getLocations(url));
  };

  const onFacilitiesApiCall = (url = "") => {
    dispatch(getClinicFacilities(url));
  };

  const getLocationList = (locationId = null) => {
    const reqList =
      locationList?.length > 0
        ? locationList
            ?.filter(
              (li) =>
                (locationId ? li?.id !== locationId : true) &&
                li?.locationType?.toLowerCase() !== "consumption",
            )
            ?.map((li) => ({
              name: li?.locationName,
              value: li?.id,
            }))
        : [];
    return reqList;
  };

  const onCreate = () => {
    setModVisible(true);
  };

  const onCloseModal = () => {
    setModVisible(false);
    setModValues({});
    setModErrors({});
  };

  const onChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = { ...modValues, [name]: value };
    setModValues(reqObj);
    setModErrors({
      ...modErrors,
      [name]: !value
        ? name === "secondaryStorage"
          ? ""
          : "This field is required"
        : "",
    });
  };

  const isFieldsNotValid = () => {
    const errObj = {};
    requiredFieldList.forEach((fld) => {
      if (!modValues?.[fld] || modValues?.[fld]?.length === 0) {
        errObj[fld] = "This field is required";
      }
    });
    setModErrors({ ...modErrors, ...errObj });
    return Object.values(errObj).some((err) => err);
  };

  const onSubmit = () => {
    if (isFieldsNotValid()) return;
    const data = {
      type: modValues?.facilityType,
      name: modValues?.name,
      status: selectedItem?.status ?? true,
    };
    if (modValues?.secondaryStorage) {
      data.secondaryStorage = modValues?.secondaryStorage;
    }
    if (modValues?.primaryStorage) {
      data.primaryStorage = modValues?.primaryStorage;
    }
    if (!selectedItem) {
      // const locObj = {
      //   locationName: modValues?.name,
      //   locationType: "Consumption",
      //   category: "Clinic",
      // };
      // dispatch(createLocation(locObj)).then((locRes) => {
      //   if (locRes?.payload) {
      //     data.primaryStorage = locRes?.payload?.data?.data?.id;
      dispatch(createFacility(data)).then((res) => {
        if (res?.payload) {
          onCloseModal();
          dispatch(getClinicFacilities(url));
          dispatch(getLocations(url));
        }
      });
      // }
      // });
    } else {
      // data.primaryStorage = selectedItem?.primaryStorage;
      dispatch(
        updateFacilityById({ data, facilityId: selectedItem?.facilityId }),
      ).then((res) => {
        if (res?.payload) {
          // if (selectedItem?.name !== modValues?.name) {
          //   const locObj = {
          //     locationName: modValues?.name,
          //     locationType: "Consumption",
          //     category: "Clinic",
          //   };
          //   dispatch(
          //     updateLocationById({
          //       locationId: selectedItem?.primaryStorage,
          //       data: locObj,
          //     })
          //   ).then((locRes) => {
          //     if (locRes?.payload) {
          //       dispatch(getLocations());
          //     }
          //   });
          // }
          onCloseModal();
          dispatch(getClinicFacilities(url));
        }
      });
    }
  };

  const handleDelete = (facility) => {
    setSelectedItem(facility);
    setDelModVisible(true);
  };

  const handleEdit = (facility) => {
    setModValues({
      facilityType: facility?.type,
      name: facility?.name,
      primaryStorage: facility?.primaryStorage,
      secondaryStorage: facility?.secondaryStorage,
    });
    setSelectedItem(facility);
    setModVisible(true);
  };

  const handleChangeSwitch = (status, facility) => {
    const data = {
      type: facility?.type,
      name: facility?.name,
      primaryStorage: facility?.primaryStorage,
      status,
    };
    if (facility?.secondaryStorage) {
      data.secondaryStorage = facility?.secondaryStorage;
    }
    dispatch(
      updateFacilityById({ data, facilityId: facility?.facilityId }),
    ).then((res) => {
      if (res?.payload) {
        dispatch(getClinicFacilities(url));
      }
    });
  };

  const getTableData = () => {
    return facilities
      ?.filter((li) =>
        li?.name?.toLowerCase()?.includes(searchValue?.toLowerCase()),
      )
      ?.map((row, index) => ({
        sNo: index + 1,
        name: row?.name,
        facilityType: nameExpan?.[row?.type],
        newStatus: (
          <div>
            <div>
              <CustomSwitch
                value={row?.status}
                onChange={(e) => handleChangeSwitch(e?.target?.value, row)}
                greenToRed
              />
            </div>
            <div>{row?.status ? "Active" : "Under Maintenance"}</div>
          </div>
        ),
        createdBy: row?.userName || "-",
        createdDate: new Date(row?.createdDate).toLocaleDateString(),
        actions: (
          <div className="flex-row-ali-cen">
            <div className="cursor" onClick={() => handleEdit(row)}>
              <div className="flex-center">
                <EditIcon sx={w20h20BlueIcon} />
              </div>
              <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                Edit
              </Typography>
            </div>
            <div className="cursor ml15" onClick={() => handleDelete(row)}>
              <div className="flex-center">
                <DeleteOutlineIcon sx={delBtn} />
              </div>
              <Typography className="red3 fs8 txt-semi-bold text-align-center">
                Delete
              </Typography>
            </div>
          </div>
        ),
      }));
  };

  const onCloseDelMod = () => {
    setDelModVisible(false);
    setSelectedItem(null);
  };

  const onConfirmDelete = () => {
    dispatch(deleteFacilityById(selectedItem?.facilityId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        dispatch(getClinicFacilities(url));
      }
    });
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Toolbar variant="regular">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <div className="top-row-cen-con w100Per">
                  <div className="w35Per">
                    <CustomTextField
                      placeholder="Search"
                      fullWidth
                      name="search"
                      handleChange={(e) => setSearchValue(e?.target?.value)}
                      value={searchValue}
                      backgroundColor={AppColors.lightBlue2}
                      //   label="Patient ID"
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton text="Create" onClick={onCreate} smallBtn />
                  </div>
                </div>
              </div>
            </Grid>
          </Toolbar>
        </Container>
      </TopBar>

      <CustomTable grey columns={tblHdrs} datas={getTableData()} />

      <CustomModal
        rightModal
        open={modVisible}
        onClose={onCloseModal}
        modalWidth={30}
        header={selectedItem ? "Edit" : "Create"}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20 mt5">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={facilityTypes}
                value={modValues?.facilityType}
                name="facilityType"
                error={!!modErrors?.facilityType}
                label="Facility Type *"
                helperText={modErrors?.facilityType}
                handleChange={onChange}
                select
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                list={facilityTypes}
                value={modValues?.name}
                name="name"
                error={!!modErrors?.name}
                label="Name *"
                helperText={modErrors?.name}
                handleChange={onChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt10">
              {/* <CustomTextField
                list={facilityTypes}
                value={modValues?.name}
                name="name"
                label="Primary Location *"
                handleChange={onChange}
                fullWidth
                disabled
              /> */}
              <CustomSelect
                list={getLocationList()}
                value={modValues?.primaryStorage}
                name="primaryStorage"
                error={!!modErrors?.primaryStorage}
                label="Primary Location *"
                helperText={modErrors?.primaryStorage}
                handleChange={onChange}
                select
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt10">
              <CustomSelect
                list={getLocationList(modValues?.primaryStorage)}
                value={modValues?.secondaryStorage}
                name="secondaryStorage"
                error={!!Location?.secondaryStorage}
                label="Secondary Location"
                helperText={modErrors?.secondaryStorage}
                handleChange={onChange}
                select
              />
            </Grid>

            <div className="flex1-center mt20">
              <div>
                <CustomButton text="Submit" onClick={onSubmit} smallBtn />
              </div>
            </div>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={delModVisible}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the facility?
        </Typography>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-center mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                smallBtn
                onClick={onConfirmDelete}
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Facilities;
